import { styled } from '@vebox/etui-system';
import '../utilities/responsive.js';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useRef, useState, useCallback, useEffect, createElement } from 'react';
import '../utilities/get-styleprop.js';
import { a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ErrorLabel/ErrorLabel.js';
import '../FormItem/FormItem.js';
import '../Input/Input.js';
import '../InputLabel/InputLabel.js';
import '../TextInput/TextInput.js';
import '../InputAddon/InputAddon.js';
import 'react-dom';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import '../Button/Button.js';
import 'react-popper';
import '../DropdownMenu/DropdownMenu.js';
import '../DropdownMenu/Item.js';
import '../DropdownMenu/Divider.js';
import '../SideDrawer/utils.js';
import SideDrawer from '../SideDrawer/SideDrawer.js';
import './constants.js';
import { filterEmptyGroups } from './utils.js';
import './colors.js';
import Content from './Content.js';
import './Group/Group.js';
import './Item/FavoriteStar.js';
import './Item/ItemDropdown.js';
import './Item/Item.js';
import './EmptyPlaceholder/EmptyPlaceholder.js';
import './Header/constants.js';
import Header from './Header/Header.js';
import './Header/HeaderButton.js';
import './Header/SearchField.js';

const MenuWrapper = styled(Div)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const defaultComponentLabels = {
  title: 'Menu',
  markFavorite: 'Mark favorite',
  unmarkFavorite: 'Unmark favorite',
  favoriteGroup: 'Favorites',
  noResultsFound: 'No results found'
};
const NewSideMenuComponent = ({
  isOpen,
  getContainer,
  groups,
  componentLabels,
  defaultFavoriteItems,
  onFavoriteItemsChange,
  onItemClick,
  styles = {},
  filterGroups,
  header
}) => {
  var _styles$drawer;
  const didMount = useRef(false);
  const [favoriteItems, setFavoriteItems] = useState(defaultFavoriteItems || []);
  const labels = _objectSpread2(_objectSpread2({}, defaultComponentLabels), componentLabels);
  const groupsWithFavorites = [{
    id: 'favorites',
    title: labels.favoriteGroup,
    iconProps: {
      glyph: icons.STAR
    },
    items: favoriteItems
  }, ...groups];
  const filteredGroups = filterGroups ? filterEmptyGroups(filterGroups(groupsWithFavorites)) : filterEmptyGroups(groupsWithFavorites);
  const checkIfFavorite = useCallback(item => {
    return !!favoriteItems.find(({
      id
    }) => id === item.id);
  }, [favoriteItems]);
  const onMarkFavorite = useCallback(item => {
    setFavoriteItems(currentFavoriteItems => [...currentFavoriteItems, item]);
  }, []);
  const onUnmarkFavorite = useCallback(item => {
    setFavoriteItems(currentFavoriteItems => currentFavoriteItems.filter(({
      id
    }) => id !== item.id));
  }, []);
  useEffect(() => {
    if (didMount.current) {
      onFavoriteItemsChange === null || onFavoriteItemsChange === void 0 ? void 0 : onFavoriteItemsChange(favoriteItems);
    } else {
      didMount.current = true;
    }
  }, [favoriteItems, onFavoriteItemsChange]);
  return /*#__PURE__*/createElement(SideDrawer, {
    collapsed: !isOpen,
    getContainer: getContainer,
    styles: _objectSpread2(_objectSpread2({}, styles.drawer), {}, {
      root: _objectSpread2({
        width: 'auto',
        top: 0,
        borderRight: 'none',
        borderLeft: 'none'
      }, (_styles$drawer = styles.drawer) === null || _styles$drawer === void 0 ? void 0 : _styles$drawer.root)
    })
  }, /*#__PURE__*/createElement(MenuWrapper, styles.root, header, /*#__PURE__*/createElement(Content, {
    groups: filteredGroups,
    componentLabels: labels,
    onMarkFavorite: onMarkFavorite,
    onUnmarkFavorite: onUnmarkFavorite,
    checkIfFavorite: checkIfFavorite,
    onItemClick: onItemClick
  })));
};
const NewSideMenu = Object.assign(NewSideMenuComponent, {
  Header
});

export default NewSideMenu;
